import React from 'react';
import { LuHeart } from 'react-icons/lu';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-4">
      <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between">
        <p className="text-sm text-gray-600">
          © {new Date().getFullYear()} LARK Finserv. All rights reserved.
        </p>
        <div className="flex items-center gap-1 mt-2 sm:mt-0">
          <span className="text-sm text-gray-600">Made with</span>
          <LuHeart className="w-4 h-4 text-red-500" />
          <span className="text-sm text-gray-600">by LARK Finserv</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;